export const componentName = 'share-drawer';
